// This file is AUTOGENERATED, do not edit it manually!!!

export const messageBoard = {
    AdditionalRecipients: 'Destinatários Adicionais',
    Ai_disabled_button: 'Comece a digitar para ativar os comandos de IA',
    Append: 'Anexar',
    Apply: 'Aplicar',
    Approve: 'Aprovar',
    Approver_Approved: 'aprovado',
    Approver_HasNotSeen: 'não lido',
    Approver_NoAction: 'nenhuma ação',
    Approver_NotApproved: 'visualizado, aprovação pendente',
    Approver_Rejected: 'rejeitado',
    ApproversGroupTitle: 'Aprovadores',
    Attachment_Delete: 'O arquivo \'{0}\' foi removido.',
    BaseNotificationRule: 'Com base na regra de notificação',
    BeforePageUnloadMessage: 'Suas alterações serão perdidas. Deseja sair desta página sem salvar as alterações?',
    Cancel: 'Cancelar',
    ChangeTone: 'Alterar tom',
    Close: 'Fechar',
    ContactAdministrator: 'Por favor, entre em contato com seu administrador',
    ContinueWriting: 'Continue escrevendo com a IA',
    Delete: 'Excluir',
    DeleteAttachmentContentTemplate: 'Tem certeza de que deseja excluir o anexo \'{0}\' ?',
    DeleteAttachmentTitle: 'Excluir anexo',
    Discard: 'Descartar',
    Download: 'Baixar',
    DropHere: 'Arraste os arquivos aqui',
    Edit: 'Editar',
    edit_actions: 'Pressione ctrl + enter para <a apply>Aplicar</a> ou esc para <a>Cancelar</a>',
    email_only_mention_title: 'Este usuário será notificado apenas por e-mail',
    Error: 'Erro',
    FilePlural: '1#{0} Arquivo#{0} Arquivos',
    FileUploadError: 'Erro',
    FileVersion: 'Versão ',
    FileVersionShort: 'ver ',
    Formal: 'Formal',
    FreeSpaceTemplate: 'Você usou {0} MB de {1} MB.',
    Friendly: 'Amigável',
    GeneratedByAi: 'Gerado pela IA...',
    HideFiles: 'Esconder arquivos',
    ImproveSpelling: 'Melhorar a ortografia e a gramática',
    ImproveWriting: 'Melhorar a escrita',
    mention_title: 'Mencionar alguém',
    Message_Delete: 'Mensagem foi excluída.',
    message_maxLength_description: 'Uma mensagem pode conter até 10.000 caracteres.',
    message_maxLength_title: 'A mensagem é muito longa',
    MessageDeleteConfirmation: 'Excluir esta postagem?',
    messageEdited: '(editado)',
    MessageEditedBy: 'Editado por ',
    messagePlaceholderText: 'Adicione uma mensagem, arraste arquivos ou @mencione alguém',
    MultipleApproversTemplate: '{0} de {1} {2}',
    MyComputer: 'Meu computador',
    NewMessageWatermark: 'Digite uma mensagem ou arraste arquivos...',
    NewPost: '1#{0} nova postagem #{0} novas postagens',
    No: 'Não',
    NoMatchRecipients: 'Membro não encontrado',
    NoPermissionToEditMessage: 'Desculpe, você não tem permissão para editar esta mensagem',
    Notification: 'Notificação',
    Notify: 'Notificar',
    NotifyLabel: 'Notificar...',
    NotProjectMembers: 'Membros não do projeto',
    OneDrive: 'OneDrive',
    OneDriveFilePicker: 'Seletor de arquivos do OneDrive',
    Optimistic: 'Otimista',
    Or: 'ou',
    PluralApproved: '1#aprovado#aprovados',
    PluralRejected: '1#{0} rejeitado#{0} rejeitados',
    Post: 'Publicar',
    PostWatingForApproval: 'Postagem aguardando aprovação',
    PreviewImages: 'Visualizar imagens',
    Professional: 'Profissional',
    ProjectMembers: 'Membros do projeto',
    Reject: 'Rejeitar',
    Replace: 'Substituir',
    RequestApprovalLabel: 'Solicitar aprovação',
    Retry: 'Tentar novamente',
    SharePoint: 'SharePoint',
    SharePointFilePicker: 'Seletor de arquivos do SharePoint',
    ShowFiles: 'Mostrar arquivos',
    ShowNext: 'Mostrar anterior',
    SingleApprovedTemplate: 'Aprovado por {0}',
    SingleApprovedTemplate_You: 'Aprovado por você.',
    SingleApproverTemplate: 'Aguardando aprovação de {0}',
    SingleRejectedTemplate: 'Rejeitado por {0}',
    SingleRejectedTemplate_You: 'Rejeitado por você.',
    Straightforward: 'Direto',
    Summarize: 'Resumir',
    SummarizeBulletPoints: 'Resumir em tópicos',
    TabEvents: 'Registro de Auditoria',
    TabFiles: 'Arquivos',
    TabMessages: 'Mensagens',
    Teams: 'Equipes',
    Undo: 'Desfazer',
    UploadedBy: 'por',
    Yes: 'Sim',
    You: 'Você',
};
